import ko from 'knockout';
import _ from 'lodash';
import MetadataService from '../../../../services/metadata.service';
import dataService from '../../../../modules/assurance/services/data.service';
import kpiAndTrendOptions from '../../dialogs/panel-options/kpi-n-trend-options/kpi-n-trend-options';
import topListOptions from '../../dialogs/panel-options/top-list-options/top-list-options';


    var KPI_TYPE = { id: 'kpi', name: 'KPI' };
    var TREND_TYPE = { id: 'trend', name: 'Trend' };

    function PanelOptionsDialogVM(config) {
        this.initialize(config);
    }

    PanelOptionsDialogVM.prototype = {

        //  bound to UI functions

        done: function () {
            var self = this;
            self.modal.close(self.panelOptions); // return all panel option created
        },

        showKPIOptions: function () {
            var self = this;
            self.showKpiTrendOptions(KPI_TYPE.id);
        },

        showTrendOptions: function () {
            var self = this;
            self.showKpiTrendOptions(TREND_TYPE.id);
        },

        showKpiTrendOptions: function (analysisId) {
            var self = this;
            dataService
                .fetchMetricsMetadata()
                .then(function (metadata) {
                    kpiAndTrendOptions
                        .dialog({
                            metadata: metadata,
                            selections: {
                                analysisId: analysisId
                            }
                        })
                        .then(function (selectedOptions) {
                            if (selectedOptions) {
                                self.panelOptions.push(selectedOptions);
                            } else {
                                self.panelOptions.push({});
                            }
                        }, function(){})// no error handling needed on close);
                });
        },

        showTopListOptions: function () {
            var self = this;
            MetadataService
                .fetchDatasetMetadataWithoutCategories()
                .then(function (metadata) {
                    topListOptions
                        .dialog({
                            metadata: metadata
                        })
                        .then(function (selectedOptions) {
                            if (selectedOptions) {
                                self.panelOptions.push(selectedOptions);
                            }
                        }, function(){})// no error handling needed on close);
                });
        },

        //  internally used-only functions

        dispose: function () {
            var self = this;
            _.forEach(self.subscriptions, function (subscription) {
                subscription.dispose();
            });
        },

        initialize: function () {
            var self = this;
            self.subscriptions = [];
            self.panelOptions = [];
            self.isDarkMode = document.documentElement.classList.contains('dark');
        }
    };

    export default PanelOptionsDialogVM;
